import { useColorMode, useColorStyle, Box } from '@tonic-one/react';
import { useTranslation } from 'react-i18next';
import { TopRiskUser } from '@Dashboard/Charts/TopRiskUser';

const TopAccountTakeoverRiskChart = (props: {
  insightsData: any;
  day: string;
}) => {
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const { t } = useTranslation();

  return (
    <Box>
      <Box
        mb="24px"
        fontSize="18px"
        fontWeight="600"
        lineHeight="24px"
        color={colorStyle.color.primary}
      >
        {t('riskUser.maliciousDistribution.title')}
      </Box>
      <TopRiskUser
        data={props.insightsData?.RiskyTopSendersTimeRange?.[props.day] || {}}
        interval={props.day}
      />
    </Box>
  );
};

export default TopAccountTakeoverRiskChart;
